import { render, staticRenderFns } from "./ViewActives.vue?vue&type=template&id=c0935f2c&scoped=true"
import script from "./ViewActives.vue?vue&type=script&lang=js"
export * from "./ViewActives.vue?vue&type=script&lang=js"
import style0 from "./ViewActives.vue?vue&type=style&index=0&id=c0935f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0935f2c",
  null
  
)

export default component.exports